(function () {
  /* --- Scroll-reveal animations --- */
  var mq = window.matchMedia("(prefers-reduced-motion: reduce)");

  function revealAll() {
    document.querySelectorAll("[data-animate]").forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  if (mq.matches || (typeof Shopify !== "undefined" && Shopify.designMode)) {
    revealAll();
    document.addEventListener("shopify:section:load", revealAll);
    document.addEventListener("shopify:section:reorder", revealAll);
    document.addEventListener("shopify:section:select", revealAll);
    document.addEventListener("shopify:block:select", revealAll);
  } else {
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "80px 0px 80px 0px", threshold: 0 }
    );

    function revealInView() {
      document.querySelectorAll("[data-animate]:not(.is-visible)").forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.98 && rect.bottom > 0) {
          el.classList.add("is-visible");
          obs.unobserve(el);
        }
      });
    }

    document.querySelectorAll("[data-animate]").forEach(function (el) {
      obs.observe(el);
    });
    revealInView();
    window.addEventListener("scroll", revealInView, { passive: true });
    window.addEventListener("resize", revealInView);
    document.addEventListener("shopify:section:load", function () {
      document.querySelectorAll("[data-animate]:not(.is-visible)").forEach(function (el) {
        obs.observe(el);
      });
      revealInView();
    });
  }

  /* --- Product gallery + description toggle --- */
  function initProductSection(root) {
    var gallery = root.querySelector("[data-product-gallery]");
    var mainImg = root.querySelector("[data-main-product-image]");
    var thumbs = root.querySelectorAll(".product-gallery__thumb[data-image]");
    var index = 0;

    function showAt(i) {
      if (!mainImg || !thumbs.length) return;
      index = (i + thumbs.length) % thumbs.length;
      var btn = thumbs[index];
      var src = btn.getAttribute("data-image");
      if (!src) return;
      mainImg.setAttribute("src", src);
      mainImg.removeAttribute("srcset");
      thumbs.forEach(function (t) { t.classList.remove("is-active"); });
      btn.classList.add("is-active");
      if (btn.scrollIntoView) {
        btn.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
      }
    }

    if (mainImg && thumbs.length) {
      thumbs.forEach(function (btn, i) {
        if (btn.classList.contains("is-active")) index = i;
        if (btn.dataset.boundThumb === "1") return;
        btn.dataset.boundThumb = "1";
        btn.addEventListener("click", function () {
          showAt(i);
        });
      });

      if (gallery && gallery.dataset.boundNav !== "1") {
        gallery.dataset.boundNav = "1";
        var prev = gallery.querySelector("[data-gallery-prev]");
        var next = gallery.querySelector("[data-gallery-next]");
        if (prev) prev.addEventListener("click", function () { showAt(index - 1); });
        if (next) next.addEventListener("click", function () { showAt(index + 1); });
      }
    }

    var features = root.querySelector(".product-info__features");
    var featuresToggle = root.querySelector("[data-features-toggle]");
    if (features && featuresToggle && featuresToggle.dataset.boundToggle !== "1") {
      featuresToggle.dataset.boundToggle = "1";
      featuresToggle.addEventListener("click", function () {
        var expanded = features.classList.toggle("is-expanded");
        featuresToggle.setAttribute("aria-expanded", String(expanded));
        featuresToggle.textContent = expanded ? "Show fewer features" : "Show more features";
      });
    }

    var steppers = root.querySelectorAll("[data-qty-stepper]");
    steppers.forEach(function (stepper) {
      if (stepper.dataset.boundQty === "1") return;
      stepper.dataset.boundQty = "1";
      var input = stepper.querySelector(".product-info__qty-input");
      var minus = stepper.querySelector("[data-qty-minus]");
      var plus = stepper.querySelector("[data-qty-plus]");
      if (!input) return;
      function clampQty(val) {
        var min = parseInt(input.getAttribute("min") || "1", 10);
        var max = parseInt(input.getAttribute("max") || "10", 10);
        var n = parseInt(val, 10);
        if (isNaN(n)) n = min;
        return Math.max(min, Math.min(max, n));
      }
      function setQty(n) {
        input.value = String(clampQty(n));
      }
      if (minus) {
        minus.addEventListener("click", function () {
          setQty(parseInt(input.value, 10) - 1);
        });
      }
      if (plus) {
        plus.addEventListener("click", function () {
          setQty(parseInt(input.value, 10) + 1);
        });
      }
      input.addEventListener("change", function () {
        setQty(input.value);
      });
    });
  }

  function initAllProductSections() {
    document.querySelectorAll(".product-main--split").forEach(initProductSection);
  }
  initAllProductSections();
  document.addEventListener("shopify:section:load", initAllProductSections);

  /* --- Mobile header menu drawer --- */
  function setupMobileNav(header) {
    if (header.dataset.mobileNavBound === "1") return;
    header.dataset.mobileNavBound = "1";
    var toggle = header.querySelector("[data-nav-drawer-toggle]");
    var section = header.closest(".shopify-section");
    var drawer = section && section.querySelector("[data-nav-drawer]");
    if (!toggle || !drawer) return;

    function closeDrawer() {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      toggle.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }
    function openDrawer() {
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      toggle.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    }

    toggle.addEventListener("click", function () {
      if (drawer.classList.contains("is-open")) closeDrawer();
      else openDrawer();
    });
    drawer.querySelectorAll("[data-nav-drawer-close]").forEach(function (el) {
      el.addEventListener("click", closeDrawer);
    });
    drawer.querySelectorAll(".nav-drawer__link").forEach(function (a) {
      a.addEventListener("click", closeDrawer);
    });
  }

  function initMobileNavAll() {
    document.querySelectorAll(".site-header").forEach(setupMobileNav);
  }
  initMobileNavAll();
  document.addEventListener("shopify:section:load", function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector(".site-header")) {
      ev.target.querySelectorAll(".site-header").forEach(setupMobileNav);
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (!document.querySelector("[data-nav-drawer].is-open")) return;
    document.querySelectorAll("[data-nav-drawer].is-open").forEach(function (drawer) {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
    });
    document.querySelectorAll("[data-nav-drawer-toggle]").forEach(function (t) {
      t.setAttribute("aria-expanded", "false");
    });
    document.body.style.overflow = "";
  });

  /* --- AJAX Add-to-Cart + Popup --- */
  function formatMoney(cents) {
    return (Shopify.currency && Shopify.currency.active ? Shopify.currency.active : "$") === "$"
      ? "$" + (cents / 100).toFixed(2)
      : (cents / 100).toFixed(2) + " " + (Shopify.currency ? Shopify.currency.active : "");
  }

  function updateHeaderBadge(count) {
    var badge = document.querySelector(".icon-badge");
    if (badge) {
      badge.textContent = count;
    } else {
      var cartIcon = document.getElementById("cart-icon-bubble");
      if (cartIcon) {
        var span = document.createElement("span");
        span.className = "icon-badge";
        span.textContent = count;
        cartIcon.appendChild(span);
      }
    }
  }

  var popup = document.getElementById("bmd-cart-popup");
  var showPopup = function () {};
  var hidePopup = function () {};
  if (popup) {
    var popupImg = document.getElementById("bmd-popup-img");
    var popupTitle = document.getElementById("bmd-popup-title");
    var popupPrice = document.getElementById("bmd-popup-price");
    var popupCount = document.getElementById("bmd-popup-count");
    var popupTotal = document.getElementById("bmd-popup-total");
    var closeBtn = popup.querySelector(".bmd-popup__close");
    var overlay = popup.querySelector(".bmd-popup__overlay");
    var hideTimer;

    showPopup = function (title, imgSrc, price) {
      popupTitle.textContent = title;
      popupImg.src = imgSrc || "";
      popupImg.alt = title;
      popupPrice.textContent = price;
      popup.classList.add("is-open");
      popup.setAttribute("aria-hidden", "false");

      fetch("/cart.js")
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          popupCount.textContent = cart.item_count + (cart.item_count === 1 ? " item" : " items");
          popupTotal.textContent = formatMoney(cart.total_price);
          updateHeaderBadge(cart.item_count);
        });

      clearTimeout(hideTimer);
      hideTimer = setTimeout(hidePopup, 5000);
    };

    hidePopup = function () {
      popup.classList.remove("is-open");
      popup.setAttribute("aria-hidden", "true");
      clearTimeout(hideTimer);
    };

    if (closeBtn) closeBtn.addEventListener("click", hidePopup);
    if (overlay) overlay.addEventListener("click", hidePopup);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") hidePopup();
    });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf("/cart/add") === -1) return;
    e.preventDefault();
    var formData = new FormData(form);
    var btn = form.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.dataset.origText = btn.innerHTML;
      btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Adding...';
    }
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        var imgSrc = "";
        if (item.featured_image && item.featured_image.url) {
          imgSrc = item.featured_image.url.replace(/(\.\w+)$/, "_300x$1");
        } else if (item.image) {
          imgSrc = item.image.replace(/(\.\w+)$/, "_300x$1");
        }
        showPopup(
          item.product_title || item.title,
          imgSrc,
          formatMoney(item.final_line_price || item.line_price)
        );
        return fetch("/cart.js");
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateHeaderBadge(cart.item_count);
      })
      .catch(function (err) {
        console.error("Add to cart error:", err);
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = btn.dataset.origText || "Add to Cart";
        }
      });
  });
})();
